export default __webpack_public_path__ + "static/media/fireTv.ac87409c.png";